// Vendor imports
const qs = require('qs')
// Client lib imports
const businessEvents = require('client/lib/business-events')
const globalPageContext = require('client/lib/business-events/page-context')
// Client V2 common imports
const { render } = require('client-v2/common/client')
// Entry imports
const configureStore = require('client-v2/logged-out-landing-v2/state/store')
const rootFactory = require('client-v2/logged-out-landing-v2/components/root').factory
// Sibling imports
const loggedOutHomeActions = require('./containers/banner-section/actions')

const { store } = render(configureStore, rootFactory)

const initialState = store.getState()
const initialRouterState = initialState.router

globalPageContext.setPageContext({
  pageName: 'stream.profile'
})

businessEvents.trackInternal('pageview')
businessEvents.trackSegment('pageview')

const { pathname, search } = initialRouterState.location
const queryParams = qs.parse(search, { ignoreQueryPrefix: true })
if (pathname === '/add' || pathname === '/mixit') {
  // Handle `/add` and `/mixit` modal route behaviors
  const url = queryParams.url || queryParams.source
  if (url) {
    store.dispatch(
      loggedOutHomeActions.show(url)
    )
  }
}
